import axios from 'axios';
import React, { useState } from 'react';
import { IconContext } from "react-icons";
import AuthContext from './components/auth/AuthContext'
import { initialStateReducer, reducer } from './components/auth/AuthReducer'
import { BrowserRouter } from 'react-router-dom'
import { SpinnerMui, SpinnerMuiContext } from './components/common/SpinnerMui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './components/common/customTostify.css'
import MatSideNav from './components/layout/MatSideNav';
import 'react-vis/dist/style.css';
import { AlertDialog, AlertDialogContext } from './components/common/AlertDialog';

function App() {
	// axios.defaults.baseURL = "http://www.behcetclini-pisa.dev.cc/wp-json" // the prefix of the URL
	axios.defaults.baseURL = "" // the prefix of the URL
	axios.defaults.headers.common['Accept'] = 'application/json'   // default header for all request
	axios.defaults.headers.post['Content-Type'] = 'application/json';
	axios.defaults.headers.put['Content-Type'] = 'application/json';
	const [state, dispatch] = React.useReducer(reducer, initialStateReducer);
	const [showSpinner, setShowSpinner] = useState<boolean>(false)
	const [showAlert, setShowAlert] = useState<boolean>(false)
	const [alertMessage, setAlertMessage] = useState<string>('')
	const package_json = require('../package.json');

	const handleAlertClose = () => {
		setShowAlert(false);
		setAlertMessage('');
	}

	return (

		<IconContext.Provider value={{className: "b-icon-global"}}>
			<AuthContext.Provider value={{state, dispatch}}>
				<SpinnerMuiContext.Provider value={{setShowSpinner}}>
					<AlertDialogContext.Provider value={{setShowAlert, setAlertMessage}}>
						<ToastContainer
							position="bottom-left"
							autoClose={4000}
							hideProgressBar={false}
							newestOnTop={false}
							closeOnClick
							rtl={false}
							pauseOnFocusLoss
							draggable={false}
							pauseOnHover
						/>
						<BrowserRouter>
							<MatSideNav version={package_json.version}/>
							{showSpinner && <SpinnerMui open={showSpinner}/>}
							{showAlert && <AlertDialog open={showAlert} onClose={handleAlertClose} message={alertMessage}/>}
						</BrowserRouter>
					</AlertDialogContext.Provider>
				</SpinnerMuiContext.Provider>
		</AuthContext.Provider>
</IconContext.Provider>
)
	;
}

export default App;
